/**
 * Theme main entry point.
 *
 * @package mindgrub-starter-theme
 */

import ui from './components/ui.js';
import registration from './components/registration.js';
import login from './components/login.js';
import dataTable from './components/data-table.js';
import accounts from './components/accounts.js';
import resetPass from './components/reset-pass.js';

/**
 * Initialize the app on DOM ready
 */
$(
	function() {
		ui.init();

		if($('.form--register').length) {
			registration.init();
		}
		if($('.form--login').length) {
			login.init();
		}
		if($('.data-table').length) {
			dataTable.init();
		}
		if($('.account, .modal--twofa.-enable').length) {
			accounts.init();
		}
		if($('.form--reset-password, .form--send-email').length) {
			resetPass.init();
		}
	}
);



// WEBPACK FOOTER //
// ./scripts/theme.js